export function splitEmails(value: string): string[] {
  return value
    .split(',')
    .map(email => email.trim())
    .filter(Boolean);
}

export function mergeUniqueEmails(existing: string[], incoming: string[]): string[] {
  const seen = new Set(existing.map(email => email.toLowerCase()));
  const merged = [...existing];

  incoming.forEach(email => {
    const normalizedEmail = email.toLowerCase();
    if (seen.has(normalizedEmail)) return;
    seen.add(normalizedEmail);
    merged.push(email);
  });

  return merged;
}

export function normalizeCcRecipients(value: string[]): string[] {
  return value.reduce<string[]>(
    (acc, item) => mergeUniqueEmails(acc, splitEmails(item)),
    [],
  );
}
